import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { MessageCircle, Cpu, TrendingUp } from 'lucide-react';

const diffs = [
  {
    icon: MessageCircle,
    title: 'Atendimento Humanizado',
    desc: 'Nada de robôs confusos. Fale direto com especialistas via WhatsApp, sempre que precisar.',
  },
  {
    icon: Cpu,
    title: 'Tecnologia e Agilidade',
    desc: 'Plataforma digital para envio e recebimento de documentos. Tudo rápido e sem burocracia.',
  },
  {
    icon: TrendingUp,
    title: 'Foco em Crescimento',
    desc: 'Não somos apenas contadores — somos consultores de negócios focados no seu sucesso.',
  },
];

export default function Differentials() {
  const sectionRef = useScrollAnimation();

  return (
    <section
      id="diferenciais"
      data-testid="differentials-section"
      ref={sectionRef}
      className="py-24 md:py-32 bg-[#0A2540]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Header */}
        <div className="scroll-fade text-center mb-16 md:mb-20">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#10B981] mb-4">
            Nossos Diferenciais
          </p>
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white tracking-tight leading-tight"
            style={{ fontFamily: "'Inter', sans-serif", letterSpacing: '-1px' }}
          >
            Por que escolher a FinContex?
          </h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 stagger-children">
          {diffs.map((item) => (
            <div
              key={item.title}
              data-testid={`differential-card-${item.title.toLowerCase().replace(/\s/g, '-')}`}
              className="scroll-fade group text-center p-8 md:p-10 border border-white/10 rounded-xl hover:border-[#10B981]/40 transition-all duration-300"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center bg-[#10B981]/15 text-[#10B981] mb-6 rounded-full group-hover:bg-[#10B981] group-hover:text-white transition-colors duration-300">
                <item.icon size={26} />
              </div>
              <h3
                className="text-xl font-bold text-white mb-3"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {item.title}
              </h3>
              <p className="text-white/60 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
